import React from 'react';

interface ActionPlansIconProps extends React.SVGProps<SVGSVGElement> {
	width?: number;
	height?: number;
	fill?: string;
}

export function ActionPlansIcon({
	width = 24,
	height = 24,
	fill = 'currentColor',
	...props
}: Readonly<ActionPlansIconProps>): JSX.Element {
	return (
		<svg
			{...props}
			fill="none"
			width={width}
			height={height}
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M19.2471 4.33443H14.2588C14.2588 3.59811 13.6682 3 12.9412 3H11.0588C10.3318 3 9.74118 3.59811 9.74118 4.33443H4.75294C4.33647 4.33443 4 4.67518 4 5.09696V20.2332C4 20.6549 4.33195 20.9957 4.74842 20.9957C4.74842 20.9957 8.30748 21.0054 10.5882 20.9957C13.9698 20.9813 19.2471 20.9957 19.2471 20.9957C19.6635 20.9957 20 20.6549 20 20.2332V5.09696C20 4.67518 19.6635 4.33443 19.2471 4.33443ZM11.2471 5.85948H9.55294V7.00328H14.4471V5.85948H12.7529V4.52506H11.2471V5.85948ZM18.5 19.5V5.85948H15.9529V8.3H8.04706V5.85948H5.5V12.341V19.5H18.5Z"
				fill={fill}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M9.66579 10.0522C9.80954 10.1815 9.8213 10.4028 9.69207 10.5465L9.09766 11.2285C9.09766 11.2285 9.09766 11.2285 8.70956 11.6591L8.70848 11.6604C8.70848 11.6604 8.62971 11.7544 8.5154 11.7852C8.39774 11.8168 8.30407 11.7772 8.28592 11.7695L8.28495 11.7691C8.25349 11.7559 8.23024 11.7408 8.2193 11.7334C8.19578 11.7175 8.17665 11.701 8.16607 11.6916C8.14255 11.6707 8.11761 11.6457 8.09564 11.6229C8.05001 11.5757 7.99474 11.5147 7.94337 11.457C7.89131 11.3984 7.84043 11.34 7.80274 11.2964L7.75716 11.2435L7.74433 11.2285L7.73997 11.2234C7.61458 11.0763 7.63183 10.855 7.77894 10.7296C7.92605 10.6042 8.14695 10.6218 8.27234 10.7689L8.27642 10.7737L8.28851 10.7878L8.33225 10.8386C8.35426 10.864 8.38069 10.8945 8.40899 10.9267L9.17151 10.0785C9.30074 9.93478 9.52204 9.92302 9.66579 10.0522Z"
				fill={fill}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M9.66579 13.0522C9.80954 13.1815 9.8213 13.4028 9.69207 13.5465L9.09766 14.2285C9.09766 14.2285 9.09766 14.2285 8.70956 14.6591L8.70848 14.6604C8.70848 14.6604 8.62971 14.7544 8.5154 14.7852C8.39774 14.8168 8.30407 14.7772 8.28592 14.7695L8.28495 14.7691C8.25349 14.7559 8.23024 14.7408 8.2193 14.7334C8.19578 14.7175 8.17665 14.701 8.16607 14.6916C8.14255 14.6707 8.11761 14.6457 8.09564 14.6229C8.05001 14.5757 7.99474 14.5147 7.94337 14.457C7.89131 14.3984 7.84043 14.34 7.80274 14.2964L7.75716 14.2435L7.74433 14.2285L7.73997 14.2234C7.61458 14.0763 7.63183 13.855 7.77894 13.7296C7.92605 13.6042 8.14695 13.6218 8.27234 13.7689L8.27642 13.7737L8.28851 13.7878L8.33225 13.8386C8.35426 13.864 8.38069 13.8945 8.40899 13.9267L9.17151 13.0785C9.30074 12.9348 9.52204 12.923 9.66579 13.0522Z"
				fill={fill}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M9.66579 16.0522C9.80954 16.1815 9.8213 16.4028 9.69207 16.5465L9.09766 17.2285C9.09766 17.2285 9.09766 17.2285 8.70956 17.6591L8.70848 17.6604C8.70848 17.6604 8.62971 17.7544 8.5154 17.7852C8.39774 17.8168 8.30407 17.7772 8.28592 17.7695L8.28495 17.7691C8.25349 17.7559 8.23024 17.7408 8.2193 17.7334C8.19578 17.7175 8.17665 17.701 8.16607 17.6916C8.14255 17.6707 8.11761 17.6457 8.09564 17.6229C8.05001 17.5757 7.99474 17.5147 7.94337 17.457C7.89131 17.3984 7.84043 17.34 7.80274 17.2964L7.75716 17.2435L7.74433 17.2285L7.73997 17.2234C7.61458 17.0763 7.63183 16.855 7.77894 16.7296C7.92605 16.6042 8.14695 16.6218 8.27234 16.7689L8.27642 16.7737L8.28851 16.7878L8.33225 16.8386C8.35426 16.864 8.38069 16.8945 8.40899 16.9267L9.17151 16.0785C9.30074 15.9348 9.52204 15.923 9.66579 16.0522Z"
				fill={fill}
			/>
			<path
				d="M10.7 10.7C10.7 10.5895 10.7895 10.5 10.9 10.5H16.5C16.6105 10.5 16.7 10.5895 16.7 10.7V11.3C16.7 11.4105 16.6105 11.5 16.5 11.5H10.9C10.7895 11.5 10.7 11.4105 10.7 11.3V10.7Z"
				fill={fill}
			/>
			<path
				d="M10.7 13.7C10.7 13.5895 10.7895 13.5 10.9 13.5H16.5C16.6105 13.5 16.7 13.5895 16.7 13.7V14.3C16.7 14.4105 16.6105 14.5 16.5 14.5H10.9C10.7895 14.5 10.7 14.4105 10.7 14.3V13.7Z"
				fill={fill}
			/>
			<path
				d="M10.7 16.7C10.7 16.5895 10.7895 16.5 10.9 16.5H16.5C16.6105 16.5 16.7 16.5895 16.7 16.7V17.3C16.7 17.4105 16.6105 17.5 16.5 17.5H10.9C10.7895 17.5 10.7 17.4105 10.7 17.3V16.7Z"
				fill={fill}
			/>
		</svg>
	);
}
